<template>
  <q-header
    class="row justify-between q-px-sm bg-grey-3"
    bordered
  >
    <div
      class="row justify-start items-center no-wrap q-gutter-sm"
      style="width: 450px;"
    >
      <q-btn
        icon="settings"
        color="grey-6"
        size="md"
        @click="$emit('show-settings')"
      />
      <kitchen-display-legend-chips />
    </div>
    <div
      v-if="kitchenDisplay"
      class="col column justify-center"
      :style="{ width: `${100 * kitchenDisplay.kitchenDisplayType.deliveryStages.length}px` }"
    >
      <span
        v-if="currentTime"
        class="full-width text-center text-subtitle2 text-black"
        style="pointer-events: none; height: 0; font-size: 0.8rem; line-height: 1rem;"
      >
        {{ currentTime }}
      </span>
      <q-tabs
        v-if="kitchenDisplay"
        :model-value="tab"
        class="text-grey"
        dense
        animated
        keep-alive
        active-color="primary"
        indicator-color="primary"
        align="justify"
        @update:model-value="value => $emit('set-tab', value)"
      >
        <q-tab
          v-for="deliveryStage in kitchenDisplay.kitchenDisplayType.deliveryStages"
          :key="deliveryStage"
          class="q-pt-sm"
          :name="deliveryStage"
          :label="deliveryStage"
        />
      </q-tabs>
    </div>
    <div
      class="row justify-end items-center no-wrap q-gutter-sm"
      style="width: 600px;"
    >
      <kitchen-display-metric-chips
        v-if="kitchenDisplay"
        ref="kitchenDisplayMetricChips"
        :auto-fetch="autoFetch"
        :kitchen-display="kitchenDisplay"
      />
      <kitchen-display-average-order-time
        v-if="kitchenDisplay"
        ref="kitchenDisplayAverageOrderTime"
        :auto-fetch="autoFetch"
        :kitchen-display="kitchenDisplay"
      />

      <q-btn
        icon="sync"
        color="grey-6"
        size="md"
        :loading="loading"
        @click="refresh"
      />
      <q-btn
        icon="assignment"
        color="grey-6"
        size="md"
        @click="$emit('show-summary')"
      >
        <slot name="summary-btn" />
      </q-btn>
    </div>
  </q-header>
</template>

<script>
import KitchenDisplayAverageOrderTime from 'src/modules/kds/components/kitchen-display-header/KitchenDisplayAverageOrderTime'
import KitchenDisplayLegendChips from 'src/modules/kds/components/kitchen-display-header/KitchenDisplayLegendChips'
import KitchenDisplayMetricChips from 'src/modules/kds/components/kitchen-display-header/KitchenDisplayMetricChips'

export default {
  name: 'KitchenDisplayHeader',
  configuration: ['currentSite'],
  components: {
    KitchenDisplayLegendChips,
    KitchenDisplayAverageOrderTime,
    KitchenDisplayMetricChips
  },
  props: {
    autoFetch: {
      type: Boolean,
      required: false,
      default: true
    },
    kitchenDisplay: {
      type: Object,
      required: false,
      default: null
    },
    tab: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['show-settings', 'set-tab', 'show-summary', 'refresh'],
  computed: {
    currentTime () {
      return this.currentSite?.siteTimeWithSeconds?.format('hh:mm A')
    }
  },
  methods: {
    refresh () {
      this.$emit('refresh')
      this.$refs.kitchenDisplayMetricChips.refresh()
      this.$refs.kitchenDisplayAverageOrderTime.refresh()
    }
  }
}
</script>
